/* istanbul ignore file */
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import { useProjectWeeklyReportsUrl } from 'domain/shared/project';
import { useParams } from 'react-router-dom';
import ProjectWeeklyReportsBreadcrumbs from 'domain/projects/project/weeklyreports/shared/ProjectWeeklyReportsBreadcrumbs';

const SingleProjectWeeklyReportBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getSingleEntityUrl } = useProjectWeeklyReportsUrl();
  const { reportId } = useParams<Dictionary<string>>();

  return (
    <ProjectWeeklyReportsBreadcrumbs>
      <SingleBreadcrumbItem entity={reportId!} link={getSingleEntityUrl(reportId)} />
      {children}
    </ProjectWeeklyReportsBreadcrumbs>
  );
};

export default SingleProjectWeeklyReportBreadcrumbs;
